import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FormatDateForAlertsService {

    constructor() {
    }

    formDate(date: string, time: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        const hour = time.substr(0, 2);
        const minute = time.substr(3, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);
        resDate.setHours(+hour, +minute);
        return resDate.toISOString();
    }

    generateDate(date: string) {
        return date.substr(0, 10);
    }

    generateTime(time: string) {
        return time.substr(11, 2) + ':' + time.substr(14, 2);
    }
}
